import Ellipsis from "ftellipsis";

export default class Cards {
    mount({ guideCardSelector, categoryCardSelector }) {
        const $guideTitles = $(
            `${guideCardSelector} .card-title-wrapper`
        ).toArray();
        const $guideSummaries = $(
            `${guideCardSelector} .card-summary-wrapper`
        ).toArray();
        const $categoryTitles = $(
            `${categoryCardSelector} .card-title-wrapper`
        ).toArray();
        const $categorySummaries = $(
            `${categoryCardSelector} .card-summary-wrapper`
        ).toArray();

        const els = [
            ...$guideTitles,
            ...$guideSummaries,
            ...$categoryTitles,
            ...$categorySummaries,
        ];

        els.length &&
            els.forEach($el => {
                const ellipsis = new Ellipsis($el);

                ellipsis.calc();
                ellipsis.set();
            });
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/cards.js